import { Component } from '@angular/core';
import { LibraryService } from '../services/library.service';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { GenerateCodesFormComponent } from './generate-codes-form/generate-codes-form.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent {
  isLoading: any;
  codes: any;

  constructor(
    private libraryService: LibraryService,
    private route: ActivatedRoute,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) {}

  ngOnInit(): void {
    this.isLoading = false;
    this.libraryService.fetchCodes().subscribe((responseData: any) => {
      this.codes = responseData;
    });
  }

  onShowGenerateCodesForm() {
    const initialState: ModalOptions = {
      animated: false,
      initialState: {},
    };

    this.bsModalRef = this.modalService.show(
      GenerateCodesFormComponent,
      initialState,
    );
    this.bsModalRef.setClass('modal-xl anim-open modal-dialog-centered');
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.onHide?.subscribe(() => {
      this.bsModalRef.setClass('modal-xl anim-close');
    });
  }
}
